// Module
var code = "<template> <require from=\"app/core/components/member/member-eligibility\"></require> <member-eligibility member-id.bind=\"memberId\"></member-eligibility> </template> ";
// Exports
module.exports = code;